import { format } from 'date-fns/esm';
import { isDate } from 'lodash';

export const TIME_FORMAT = 'h:mm a';
export const HUMAN_DATE_FORMAT = 'd MMM h:mm a';
export const FULL_HUMAN_DATE_FORMAT = 'd MMM YYY h:mm a';

export const formatDate = (date, formatter = HUMAN_DATE_FORMAT, multiplier = 1000) => {
  const dateValue = isDate(date) ? date : new Date(date * multiplier);
  return format(dateValue, formatter);
};

export function formatIsoDate(dateString) {
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}



// WEBPACK FOOTER //
// ./app/javascript/common/utils/format.js